import App from "./App.svelte";

function initLogins() {
    [...document.querySelectorAll(".js-login")].forEach((targetContainer, index) => {
        new App({
            target: targetContainer,
            props: {
                registerEventListener: !index,
            },
        });
    });
}

export default initLogins;
